import script from "./DomainsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DomainsSection.vue?vue&type=script&setup=true&lang=ts"

import "./DomainsSection.vue?vue&type=style&index=0&id=1b259ad8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b259ad8"]])

export default __exports__